import Logo from "../../assets/img/logo.png";
import { IoLocationSharp } from "react-icons/io5";
import { FaPhoneAlt } from "react-icons/fa";
import { IoIosMail } from "react-icons/io";
import { BsFillSendFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import { useState } from "react";
import axiosClient from "../../api";
import { toast } from "react-toastify";

const Footer = () => {
  const [formData, setFormData] = useState({
    FirstName: "Footer İletişim",
    lastName: "Footer İletişim",
    email: "",
    PhoneNumber: "Footer İletişim",
    productId: "a7313497-723c-40b3-941f-30c68ecd8a36",
    message: "Footer İletişim",
  });

  const onSubmit = (values) => {
    // Handle form sbmission logic here
    axiosClient
      .post("/Contact", values)
      .then((res) => {
        toast.success("Mesajınız başarıyla gönderildi.");
        setFormData({
          FirstName: "Footer İletişim",
          lastName: "Footer İletişim",
          email: "",
          PhoneNumber: "Footer İletişim",
          productId: "a7313497-723c-40b3-941f-30c68ecd8a36",
          message: "Footer İletişim",
        });
      })
      .catch((error) => {
        toast.error("Mesaj gönderilemedi. Lütfen tekrar deneyin.");
      });
  };
  return (
    <footer className="bg-main text-white">
      <div className="container py-16">
        <div className="flex gap-5 max-md:flex-col">
          <div className="flex-[2_2_0]">
            <img src={Logo} alt="Logo" class="w-48" />
            <div className="mt-10">
              <p className="mb-3 font-semibold">İstanbul Ofis:</p>
              <ul>
                <li className="flex items-center gap-2 mb-2">
                  <IoLocationSharp className="flex-1" />
                  <span className="flex-[9_9_0]">
                    Kaptanpaşa Mah. Halit Ziya Türkkan Sok. Famas Plaza C Blok
                    No: 19 Şişli / İstanbul
                  </span>
                </li>
                <li className="flex items-center gap-2 mb-2">
                  <FaPhoneAlt className="flex-1" />
                  <span className="flex-[9_9_0]">
                    <a href="tel:+908507377564">+90 850 737 7564</a>
                  </span>
                </li>
                <li className="flex items-center gap-2">
                  <IoIosMail className="flex-1" />
                  <span className="flex-[9_9_0]">
                    <a href="mailto:info@lensa.com.tr">info@lensa.com.tr</a>
                  </span>
                </li>
              </ul>
            </div>
            <div className="mt-10">
              <p className="mb-3 font-semibold">Ankara Ofis:</p>
              <ul>
                <li className="flex items-center gap-2 mb-2">
                  <IoLocationSharp className="flex-1" />
                  <span className="flex-[9_9_0]">
                    Ehlibeyt Mahallesi Tekstilciler Caddesi. Bayraktar Plaza
                    No:17A D:29 Çankaya / Ankara
                  </span>
                </li>
                <li className="flex items-center gap-2 mb-2">
                  <FaPhoneAlt className="flex-1" />
                  <a className="flex-[9_9_0]" href="tel:+908507377564">
                    +90 850 737 7564
                  </a>
                </li>
                <li className="flex items-center gap-2">
                  <IoIosMail className="flex-1" />
                  <a className="flex-[9_9_0]" href="mailto:info@lensa.com.tr">
                    info@lensa.com.tr
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="flex-[2_2_0] flex items-center flex-col max-md:items-start max-md:mt-5">
            <div>
              <p className="text-xl font-bold mb-2">Faydalı Linkler</p>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link to="/urunler" className="hover:underline">
                    Ürünler
                  </Link>
                </li>
                <li>
                  <Link to="/hakkimizda" className="hover:underline">
                    Hakkımızda
                  </Link>
                </li>
                <li>
                  <Link to="/referanslar" className="hover:underline">
                    Referanslarımız
                  </Link>
                </li>
                <li>
                  <Link
                    to="/cerez-aydinlatma-metni"
                    className="hover:underline"
                  >
                    Çerez Aydınlatma Metni
                  </Link>
                </li>
                <li>
                  <Link
                    to="/whatsapp-chatbot-aydinlatma-metni"
                    className="hover:underline"
                  >
                    Whatsapp Chatbot Aydınlatma Metni
                  </Link>
                </li>
                <li>
                  <Link to="/iletisim" className="hover:underline">
                    İletişim
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="flex-[2_2_0] max-md:mt-5">
            <p className="text-xl font-bold mb-2">İLETİŞİME GEÇİN</p>
            <p className="text-xs mb-5">
              Bülten aboneliği yalnızca ticari müşterilerimiz için olup,
              bireysel amaçlı kullanımlar için ürün /hizmet satışımız
              bulunmamaktadır. Bültene abone olurken esnaf/tacir olarak
              aboneliğinizin dikkate alınacağını lütfen dikkate alınız.
            </p>
            <p>
              Bültenimize abone olun ve bir sonraki satın alma işleminizde bonus
              kazanın
            </p>

            <div className="flex mt-5">
              <input
                type="text"
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                value={formData.email}
                placeholder="E-Posta"
                className="flex-1 focus:outline-none px-3 py-2 rounded-sm text-main"
              />
              <button
                onClick={() => onSubmit(formData)}
                className="bg-white text-main border-l-2 border-main px-5 py-2 rounded-sm"
              >
                <BsFillSendFill size={21} />
              </button>
            </div>
            <p className="text-xs mt-5">
              Yukarıdaki alanda tarafımıza açıklayacağınız e-posta şeklindeki
              kişisel veriniz, açık rızanızın olması durumunda LENSA Bilişim
              Teknolojileri Sanayi ve Ticaret Anonim Şirketi tarafından Reklam /
              Kampanya / Promosyon Süreçlerinin Yürütülmesi, Ürün / Hizmetlerin
              Pazarlama Süreçlerinin Yürütülmesi, İletişim Faaliyetlerinin
              Yürütülmesi amaçlarıyla işlenecektir. Ayrıntılı bilgiye{" "}
              <Link className="font-bold" to="/e-bulten-aydinlatma-metni">
                E-Bülten Aydınlatma Metni
              </Link>{" "}
              üzerinden erişebilirsiniz.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
